/**
 * Variant-Specific Bundle Toggle
 *
 * Custom script for showing/hiding Sternify bundles based on selected product variant.
 * Uses the SternifyCartInterceptor to detect variant changes.
 *
 * INSTALLATION:
 * 1. Add this script tag to the customer's theme (after cartInterceptor.js):
 *    <script src="{{ 'variant-specific-bundle-toggle.js' | asset_url }}" defer></script>
 *
 * 2. Update the ALLOWED_VARIANT_IDS array below with the variant IDs that should show the bundle
 *
 * HOW TO FIND VARIANT IDS:
 * - Open product page in browser
 * - Open console (F12) and run: window.SternifyCartInterceptor.variantInput.value
 * - Or check URL parameter: ?variant=XXXXXX
 */

(function() {
  'use strict';

  // ============================================
  // CONFIGURATION - UPDATE THESE VALUES
  // ============================================

  /**
   * The product ID where variant filtering should be applied
   * This script will ONLY run on this specific product
   * All other products will be ignored
   */
  const TARGET_PRODUCT_ID = 15071432016204; // e.g., 7234567890

  /**
   * Array of variant IDs that should show the bundle
   * Only these variants will display the bundle on the target product
   */
  const ALLOWED_VARIANT_IDS = [
    53301503000908,
    53301503099212
  ];

  // ============================================
  // BUNDLE VISIBILITY CONTROL
  // ============================================

  function getCurrentProductId() {
    // Method 1: Shopify global object (most common)
    if (window.ShopifyAnalytics?.meta?.product?.id) {
      return parseInt(window.ShopifyAnalytics.meta.product.id);
    }

    // Method 2: Meta product object (Shopify 2.0 themes)
    if (window.meta?.product?.id) {
      return parseInt(window.meta.product.id);
    }

    // Method 3: Theme-specific product object
    if (window.product?.id) {
      return parseInt(window.product.id);
    }

    return null;
  }

  function getCurrentVariantId() {
    if (!window.SternifyCartInterceptor?.variantInput) {
      return null;
    }

    const variantId = window.SternifyCartInterceptor.variantInput.value;
    return variantId ? parseInt(variantId) : null;
  }

  function shouldShowBundle(variantId) {
    // If no variant IDs configured, always show (fail-safe)
    if (ALLOWED_VARIANT_IDS.length === 0) {
      console.warn('[Sternify] No variant IDs configured. Bundle will always show.');
      return true;
    }

    // If no variant detected, hide bundle
    if (!variantId) {
      return false;
    }

    // Check if current variant is in the allowed list
    const isAllowed = ALLOWED_VARIANT_IDS.some(id => parseInt(id) === variantId);

    console.log('[Sternify Variant Toggle]', {
      currentVariant: variantId,
      isAllowed: isAllowed,
      allowedVariants: ALLOWED_VARIANT_IDS
    });

    return isAllowed;
  }

  function updateBundleVisibility() {
    const variantId = getCurrentVariantId();
    const show = shouldShowBundle(variantId);

    // Find bundle containers
    const bundleContainers = [
      document.getElementById('sternify-bundle'),
      document.getElementById('sternify-variant-bundle')
    ].filter(Boolean);

    bundleContainers.forEach(container => {
      if (show) {
        container.style.display = 'block';
      } else {
        container.style.display = 'none';
      }
    });
  }

  // ============================================
  // INITIALIZATION
  // ============================================

  function init() {
    console.log('[Sternify Variant Toggle] Initializing...');

    // Check if we should run on this product
    if (!TARGET_PRODUCT_ID) {
      console.warn('[Sternify Variant Toggle] No target product ID configured. Script will not run.');
      return;
    }

    const currentProductId = getCurrentProductId();

    // If not on target product, exit immediately
    if (currentProductId !== TARGET_PRODUCT_ID) {
      console.log(`[Sternify Variant Toggle] Not on target product (current: ${currentProductId}, target: ${TARGET_PRODUCT_ID}). Exiting.`);
      return;
    }

    console.log(`[Sternify Variant Toggle] On target product ${TARGET_PRODUCT_ID}. Activating variant filtering.`);

    // Wait for SternifyCartInterceptor to be ready
    if (!window.SternifyCartInterceptor) {
      window.addEventListener('SternifyCartInterceptorReady', init);
      return;
    }

    // Run initial check
    updateBundleVisibility();

    // Watch for variant input changes using MutationObserver
    const variantInput = window.SternifyCartInterceptor.variantInput;
    if (variantInput) {
      const observer = new MutationObserver(updateBundleVisibility);
      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });

      // Also listen to change events
      variantInput.addEventListener('change', updateBundleVisibility);
    }

    // Listen to URL changes (for themes using pushState)
    window.addEventListener('popstate', updateBundleVisibility);

    // Listen to variant change events from Sternify
    document.addEventListener('variant:change', updateBundleVisibility);

    console.log('[Sternify Variant Toggle] Initialized');
  }

  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
